import { inmunetApi } from '../../../api';

export const getMedico = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/medicoAdmin/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.medico;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};